module.exports = __webpack_public_path__ + "static/media/12_5.7533aba1.jpg";